import { render, staticRenderFns } from "./index.old.vue?vue&type=template&id=01b6c19b"
import script from "./index.old.vue?vue&type=script&lang=js"
export * from "./index.old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports